
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import CollapseItem from '@/components/collapse.vue';
  import shoplist from "@/components/shoplist.vue";
  import chooseCoupon from "@/components/chooseCoupon.vue"
  import choosePrize from "@/components/choosePrize.vue"
  import uploadImg from "@/components/upload-img.vue"
	import Message from '@/components/message.vue';
  import {
    activityInviteFriendedit,
    activityInviteFriendsave
  } from "@/api/live"
  @Component({  
    name: '',
    components: {
      PageFooter,
      CollapseItem,
      shoplist,
      chooseCoupon,
      uploadImg,
      choosePrize,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private pageloading = false
    private form:any = {
      Id:0,
      ActivityInviteFriendState:0,
      ActivityName:'',
      StartTime:'',
      EndTime:'',
      ActivityDescription:'',
      JoinMemberType:[],
      InviteMemberType:0,
      SuccessInviteMemberCount:'',
      MaxJoinCount:'',
      EquityType:1,//赠送优惠券 以后可能会加 接口目前没有这个字段
      ActivityInviteFriendCouponEditResponse:[],
      HeaderImgUrl:[],
    }
    private levellist = [
      {
      	label: '客户(含已注册代理待审核状态的人)',
      	value: 0
      }, {
        label: '联创',
        value: 1
      }, {
        label: '核心',
        value: 2
      }, {
        label: '总代',
        value: 3
      },
    ]
    private ActivityInviteFriendCouponEditResponse:any = []
    private total2 = 0;
    private pageSize2 = 10;
    private pageNo2 = 1;
    private chooseShow = false
    private saveShow = false

    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getInfo()
      }
    }

    private async getInfo(){
      try{
        this.pageloading = true
        let res = await activityInviteFriendedit({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          let form = res.Result
          form.Id = this.$route.query.Id
          form.EquityType = 1
          form.ActivityInviteFriendCouponEditResponse = form.ActivityInviteFriendCouponEditResponse.map(v=>{
            v.Id = v.ActivityCouponId
            v.LeaveCount = v.RemainCount

            return v
          })

          form.HeaderImgUrl = [form.HeaderImgUrl]
          this.form = JSON.parse(JSON.stringify(form))
          this.getActivityPayGiftEquityList()
        }
      }finally{
        this.pageloading = false
      }
    }
    private async confirmSave(){
      try{
        this.pageloading = true
        let form = JSON.parse(JSON.stringify(this.form))
        form.ActivityInviteFriendCouponSave = form.ActivityInviteFriendCouponEditResponse.map(v=>{
          return {
            ActivityInviteFriendCouponId:v.ActivityInviteFriendCouponId,
            ActivityInviteFriendId:v.ActivityInviteFriendId,
            ActivityCouponId:v.ActivityCouponId,
            CouponGiveCount:v.CouponGiveCount,
          }
        })
        delete form.ActivityInviteFriendCouponEditResponse
        form.HeaderImgUrl = form.HeaderImgUrl[0]
        let res:any = await activityInviteFriendsave(form)
        if(res.IsSuccess){
          this.$message.success('保存成功')
          this.$router.go(-1)
        }
      }finally{
        this.pageloading = false
      }
    }
    private tosave(){
      let two = /^\d+(\.\d{1,2})?$/
      if(!this.form.ActivityName){
        this.$message.error('请输入活动名称')
        return 
      }
      if(!this.form.StartTime||!this.form.EndTime){
        this.$message.error('请完善活动时间')
        return 
      }
      if(new Date(this.form.StartTime).getTime()>new Date(this.form.EndTime).getTime()){
        this.$message.error('开始时间不能晚于结束时间')
        return 
      }
      if(!this.form.JoinMemberType||!this.form.JoinMemberType.length){
        this.$message.error('请选择参与人群')
        return 
      }
      if(!this.form.SuccessInviteMemberCount){
        this.$message.error('请设置活动要求')
        return 
      }
      if(this.form.SuccessInviteMemberCount<1||this.form.SuccessInviteMemberCount>999){
        this.$message.error('活动要求请设置1~999间的整数')
        return 
      }
      if(this.form.MaxJoinCount<0||this.form.MaxJoinCount>999){
        this.$message.error('活动限制请设置0~999间的整数')
        return 
      }
      if(!this.form.ActivityInviteFriendCouponEditResponse||!this.form.ActivityInviteFriendCouponEditResponse.length){
        this.$message.error('请选择要赠送的优惠券')
        return 
      }
      for(let item of this.form.ActivityInviteFriendCouponEditResponse){
        if(item.CouponGiveCount<1||item.CouponGiveCount>100){
          this.$message.error('赠送数量请控制在1~100的数值')
          return
        }
      }
      if(!this.form.HeaderImgUrl||!this.form.HeaderImgUrl.length){
        this.$message.error('请设置活动头部图')
          return 
      }
      this.saveShow = true
    }

    private uploadSuc(file,key){
      this.form[key] = file
    }
    private blurSend(e,row){
      if(row.CouponGiveCount<1||row.CouponGiveCount>100||row.CouponGiveCount!=parseInt(row.CouponGiveCount)){
        this.$message.error('赠送数量请控制在1~100的数值')
        this.form.ActivityInviteFriendCouponEditResponse = this.form.ActivityInviteFriendCouponEditResponse.map(v=>{
          if(row.ActivityCouponId==v.ActivityCouponId){
            row.CouponGiveCount = ''
          }
          return v
        })
        this.getActivityPayGiftEquityList();
        return 
      }
    }
    private getData(list){
      if(!list||!list.length){
        this.$message.error('请选择要赠送的优惠券')
        return
      }
      if(list.length>20){
        this.$message.error('最多可添加20张优惠券')
        return
      }
      this.form.ActivityInviteFriendCouponEditResponse = JSON.parse(JSON.stringify(list)).map(v=>{
        v.ActivityInviteFriendCouponId = 0
        v.ActivityInviteFriendId = this.$route.query.Id
        v.ActivityCouponId = v.Id
        v.CouponGiveCount = ''
        let old = this.form.ActivityInviteFriendCouponEditResponse.find(x=>x.ActivityCouponId==v.ActivityCouponId)
        if(old&&old.Id){
          v.CouponGiveCount = old.CouponGiveCount
          v.ActivityInviteFriendCouponId = old.ActivityInviteFriendCouponId
        }
        return v
      });
      this.chooseShow = false
      this.getActivityPayGiftEquityList();
    }
    private delrow2(row) {
      this.form.ActivityInviteFriendCouponEditResponse = this.form.ActivityInviteFriendCouponEditResponse.filter((v) => {
        return v.ActivityCouponId != row.ActivityCouponId;
      });
      this.getActivityPayGiftEquityList();
    }
    private changePage2(e){
      this.pageNo2 = e;
      this.getActivityPayGiftEquityList();
    }
    private getActivityPayGiftEquityList(){
      this.total2 = this.form.ActivityInviteFriendCouponEditResponse.length;
      this.ActivityInviteFriendCouponEditResponse = this.form.ActivityInviteFriendCouponEditResponse.filter((v, i) => {
        return (i >= (this.pageNo2 - 1) * this.pageSize2 &&i < this.pageNo2 * this.pageSize2);
      });
      if (this.pageNo2 > 1 && (!this.ActivityInviteFriendCouponEditResponse || !this.ActivityInviteFriendCouponEditResponse.length)) {
        this.pageNo2--;
        this.getActivityPayGiftEquityList();
      }
    }
  }
